import { createUseStyles } from '@glu/theming';

/* istanbul ignore next */
export const depositSlipTheme = ({
  palette: {
    grey: { G100 }
  }
}) => ({
  background: G100
});

/* istanbul ignore next */
const styles = ({ depositSlip: { background } }) => ({
  wrapper: {
    background
  }
});

export default createUseStyles(styles);
